import g from '#core/global';
import load from '#core/load';
import expandable from '#partial/expandable/expandable';

const group_$ = '.toggle-field-group';
const select_group_$ = '.toggle-field-group--select-style';
const option_$ = '.toggle-field-option';
const option_input_$ = '.toggle-field-option__input';
const option_label_$ = '.toggle-field-option__label';
const summary_all_attr = 'data-summary-all';
const summary_current_attr = 'data-summary-current';
const summary_delimiter = ', ';
const select_style_responsive_c = 'toggle-field-group--select-style-at-';

let has_group = false;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('toggle-field-group')) return false;
		
		load.content(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
		load.all(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_group) return true;
	
	document.addEventListener(g.change_e, e => {
		const $group = e.target.closest(group_$);
		if (!$group) return;
		
		// Close select group
		if (
			$group.matches(select_group_$)
			|| $group.classList.toString().includes(select_style_responsive_c)
		) {
			const $expandable = $group.closest('.expandable');
			if ($expandable) {
				expandable.toggle({
					id: $expandable.id,
					force: false,
				});
			}
		}
		
		update_summary($group);
	});
	
	return true;
}


/**
 * Update the group summary attribute based on checked options
 * @param {HTMLElement} $group
 */
function update_summary($group) {
	const $options = $group.querySelectorAll(option_$);
	
	let summary = [];
	$options.forEach($option => {
		const $option_input = $option.querySelector(option_input_$);
		if (!$option_input || !$option_input.checked) return false;
		
		const $label = $option.querySelector(option_label_$);
		if (!$label) return false;
		
		const label = $label.textContent || '';
		summary.push(label.trim());
	});
	
	summary = summary.filter(x => x).join(summary_delimiter);
	if (!summary.length) {
		summary = $group.getAttribute(summary_all_attr);
	}
	
	// Store summary in data attribute for parent (expandable-field-group) to read
	$group.setAttribute(summary_current_attr, summary);
}
